import { get } from 'lodash-es';
import { Features } from '../../../../../../../../../../frontend/libs/shared/src/lib/types/features';

/**
 * This mainly serves as an abstraction layer for the data and the content layout
 *
 * If we want to replace the header layout we should simply update or replace core-header-details component
 * not this parent component
 */
export class CoreHeaderCtrl {
  rfp: any;
  contract: any;
  account: any;
  featureList: Features;

  details: any;

  constructor(
    private $filter: any,
    private HeaderDetailsContract: any,
    private HeaderDetailsRfp: any,
  ) {
    'ngInject';
  }

  $onChanges(changes: any) {
    changes = changes || {};

    let contract = get(changes, 'contract.currentValue');
    let rfp = get(changes, 'rfp.currentValue');
    let account = get(changes, 'account.currentValue');
    let featureList = get(changes, 'featureList.currentValue');
    if (changes && featureList) {
      // console.log('has FeatureList DATA', featureList);
    }

    if (changes && account) {
      // account data is only required for the timeline
      // though we could simply pass in isBuyer: boolean
      // console.log('has Account DATA', account);
    }

    if (changes && contract) {
      // console.log('has Contract DATA', contract);
      this.details = this.HeaderDetailsContract(contract);
    }

    if (changes && rfp) {
      // console.log('has RFP DATA', rfp);
      this.details = this.HeaderDetailsRfp(rfp);
    }
  }
}

export const CoreHeaderComponent = {
  bindings: {
    rfp: '<',
    contract: '<',
    featureList: '<',
    account: '<',
    attachments: '<',
    planName: '<',
    planLastModifiedBy: '<',
    planLastModifiedDate: '<',
    isPlanUnsaved: '<',
    isPlanPublished: '<',
    isOptimizedMix: '<',
    sellerName: '<',
    purchasePlanningLevel: '<',
    activePlanMixStatus: '<',
    planWasSaved: '<',
    activePurchasePlan: '<',
  },
  controller: CoreHeaderCtrl,
  transclude: {
    customCategoryNameField: '?customCategoryNameField',
  },
  template: `<div>
    <!-- core-header-details consolidates rfp-details and contract-details -->
    <core-header-details
      account="$ctrl.account"
      details="$ctrl.details"
      feature-list="$ctrl.featureList"
      attachments="$ctrl.attachments"
      plan-name="$ctrl.planName",
      plan-last-modified-by="$ctrl.planLastModifiedBy",
      plan-last-modified-date="$ctrl.planLastModifiedDate",
      is-plan-unsaved="$ctrl.isPlanUnsaved",
      is-plan-published="$ctrl.isPlanPublished"
      is-optimized-mix="$ctrl.isOptimizedMix"
      active-plan-mix-status="$ctrl.activePlanMixStatus"
      seller-name="$ctrl.sellerName"
      purchase-planning-level="$ctrl.purchasePlanningLevel"
      is-optimized-mix-tooltip-open="$ctrl.isOptimizedMix"
      plan-was-saved="$ctrl.planWasSaved"
      active-purchase-plan="$ctrl.activePurchasePlan"
      >
      <custom-category-name-field ng-transclude="customCategoryNameField">
        <strong title="{{ $ctrl.details.categoryName }}" class="truncate-label ellipsis">{{ $ctrl.details.categoryName }}</strong>
        <strong title="{{ $ctrl.rfp.categorizationSchemeName }}"
                data-test-selector='category-scheme-name'
                class="truncate-label ellipsis">~ {{$ctrl.rfp.categorizationSchemeName}}</strong>
      </custom-category-name-field>
    </core-header-details>
  </div>`,
};
